// Module
var code = "<div class=\"footer\"> <div> <strong>Copyright</strong> Real Time Risk Solutions &copy; {{ currentYear }} </div> </div> ";
// Exports
module.exports = code;